import type { MapaCargo } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'

export const CARGO_GESTOR_DE_TRAFEGO: MapaCargo = 
{
  id: 'gestor-de-trafego',
  titulo: 'Gestor de Tráfego',
  setor: 'Performance',
  secoes: [
    {
      id: 'execucao-de-campanhas-de-trafego-pago',
      titulo: 'Execução de Campanhas de Tráfego Pago',
      atividades: [
        'Subir anúncios nas plataformas de tráfego pago (Google Ads, Facebook Ads, Instagram Ads, LinkedIn Ads, entre outras).',
        'Configuração de campanhas com base em diretrizes fornecidas pelas equipes de planejamento, incluindo o carregamento de criativos e definição de parâmetros técnicos (orçamento, segmentação, anúncios e formatos).',
      ],
    },
    {
      id: 'gerenciamento-de-anuncios-ativos-garantindo-que-os-criativos',
      titulo: 'Gerenciamento de anúncios ativos, garantindo que os criativos e as segmentações estejam corretamente configurados nas plataformas',
      atividades: [
      ],
    },
    {
      id: 'monitoramento-de-desempenho',
      titulo: 'Monitoramento de Desempenho',
      atividades: [
      ],
    },
    {
      id: 'acompanhamento-diario-das-campanhas-para-garantir-que-os-anu',
      titulo: 'Acompanhamento diário das campanhas para garantir que os anúncios estejam rodando sem problemas técnicos, ajustando qualquer erro que possa surgir durante a execução',
      atividades: [
        'Ajuste de orçamentos e lances conforme necessário, com base no desempenho imediato de cada campanha.',
      ],
    },
    {
      id: 'otimizacao-de-campanhas',
      titulo: 'Otimização de Campanhas',
      atividades: [
        'Ajustar criativos, segmentações e anúncios com base no desempenho em tempo real, conforme feedback das campanhas.',
      ],
    },
    {
      id: 'revisao-de-anuncios-e-solicitacao-de-ajustes-conforme-as-met',
      titulo: 'Revisão de anúncios e solicitação de ajustes conforme as métricas de CPC, CTR, CPM para garantir que as campanhas sigam eficientes',
      atividades: [
      ],
    },
    {
      id: 'gerenciamento-de-segmentacoes-e-publicos',
      titulo: 'Gerenciamento de Segmentações e Públicos',
      atividades: [
        'Ajustar segmentação de anúncios de acordo com as instruções da equipe de marketing, garantindo que o público-alvo esteja correto durante a execução da campanha.',
        'Atuar na correção de erros de segmentação ou qualquer tipo de falha técnica nas campanhas, sempre com o apoio do time de planejamento.',
      ],
    },
    {
      id: 'acompanhamento-das-ferramentas-de-anuncios',
      titulo: 'Acompanhamento das Ferramentas de Anúncios',
      atividades: [
        'Operar plataformas de tráfego pago (Google Ads, Facebook Ads, etc.) diariamente, garantindo que as campanhas rodem de acordo com o previsto.',
        'Monitorar ferramentas de otimização automática das plataformas para garantir que as campanhas estão sendo executadas conforme o esperado.',
        'Analista de Tráfego 2026',
      ],
    },
  ],
}
